import axios from "axios";
import axiosInstance from "services/axiosInstance";
import { Params, redirect, useLocation, useNavigate } from "react-router-dom";

import AppNavigation from "./AppNavigation";
import { AddressBookFormAction } from "views/campaign/CampaignAddressBook";
import { AddressBookDetailsFormAction } from "views/address-books/AddressBookDetails";
import { AddressBookListAction } from "views/address-books/AddressBooks";
import { HomeAction } from "views/home/Home";

// import manage messages
import { Bounce, ToastContainer, ToastContainerProps, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { setMessage } from "messages/messages";
import { useEffect } from "react";
import { Modal } from "antd";



// ====================================== Login action =============================================
export const login = async ({ request }: { request: Request }) => {
    try {
        // Prepare payload
        let formData = await request.formData();
        let payload = Object.fromEntries(formData.entries());
        console.log("Payload:", payload);

        // Post payload
        let response = await axiosInstance.post(
            process.env.REACT_APP_API_AUTH_ENDPOINT as string,
            payload
        );
        console.log("API response:", response);

        // Store tokens
        localStorage.setItem("access_token", response.data["access"]);
        localStorage.setItem("refresh_token", response.data["refresh"]);

        // Redirect to home
        return redirect(AppNavigation.Home);
    } catch (error) {
        console.error("Error while trying to authenticate against API:", error);

        if (axios.isAxiosError(error) && error.response?.status === 401) {
            return setMessage("error", "No active account found with the given credentials");
        } else {
            return setMessage("error", "Authentication failed");
        }
    }
};

// ======================================== CCONNECTION WITH EMAIL AND PASSWORD =================================
export const loginWithEmailAndPassword = async ({ request }: { request: Request }) => {
    try {
        // Prepare payload
        const fromData = await request.formData();
        const payload = Object.fromEntries(fromData.entries());
        console.log("Payload from Formdata ===============> :", payload);

        // Convert payload to JSON
        const jsonPayload = JSON.stringify({
            email: payload.email,
            password: payload.password
        });
        console.log("Payload json to api =================> :", jsonPayload);
        console.log("\t # API URL ===========> :", `${process.env.REACT_APP_BASE_API_URL}`);

        // Post payload in api
        const response = await axiosInstance.post(
            `${process.env.REACT_APP_BASE_API_URL}${process.env.REACT_APP_API_CONNECTION_WINTH_EMAIL_AND_PASSWORD_ENDPOINT}`,
            jsonPayload,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
        console.log("Response from api :", response);

        // Verify the response for api server, if OK send the activation code
        if (response.status === 200) {
            // Store tokens
            localStorage.setItem("access_token", response.data["access"]);
            localStorage.setItem("refresh_token", response.data["refresh"]);

            // Redirect to home
            return redirect(AppNavigation.Home);
        } else if (response.status === 403) {
            return setMessage("error", "No active account found with the given credentials");
        } else if (response.status === 401 || response.status === 404 || response.status === 400) {
            return setMessage("error", "User not found");
        }
        else {
            return setMessage("error", "Authentication failed");
        }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response?.status === 500) {
            return setMessage("error", "server error");
        } else {
            return setMessage("error", "Authentication failed");
        }
    }
}

// ============================================ REGISTER ACTION =====================================
export const register = async ({ request }: { request: Request }) => {
    try {
        // Préparation des données du formulaire
        const formData = await request.formData();
        const payload = Object.fromEntries(formData.entries());

        // Vérification des champs requis
        if (!payload.email || !payload.username || !payload.first_name || !payload.password) {
            return setMessage("error", "Tous les champs sont obligatoires");
        }

        // Conversion des données en JSON
        const jsonPayload = JSON.stringify({
            email: payload.email,
            username: payload.username,
            first_name: payload.first_name,
            password: payload.password
        });

        console.log("Payload de l'API :", jsonPayload);

        // Envoi des données à l'API
        const response = await axios.post(
            `${process.env.REACT_APP_BASE_API_URL}${process.env.REACT_APP_API_REGISTER_USER_ENDPOINT}`,
            jsonPayload,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );

        console.log("Réponse de l'API :", response);

        // Vérification de la réponse de l'API
        if (response.status === 200 || response.status === 201) {
            const sendActivationCode = await axios.post(
                `${process.env.REACT_APP_BASE_API_URL}${process.env.REACT_APP_API_SEND_ACTIVATION_CODE_ENDPOINT}`,
                { email: payload.email },
                {
                    headers: {
                        "Content-Type": "application/json"
                    }
                }
            );

            if (sendActivationCode.status === 200) {
                console.log("Code d'activation envoyé à votre email");
                setMessage("info", "Code d'activation envoyé à votre email.");
                return redirect(AppNavigation.SendActivationCode);
            } else {
                console.log("Échec de l'envoi du code d'activation");
                return setMessage("error", "Échec de l'envoi du code d'activation");
            }
        } else if (response.status === 400) {
            console.log("Erreur 400 : Données invalides", response.data);
            return setMessage("error", "Données invalides");
        } else {
            return setMessage("error", "Une erreur s'est produite lors du traitement");
        }

    } catch (error) {
        console.error("Erreur lors de la tentative d'inscription via l'API :", error);
        if (axios.isAxiosError(error) && error.response?.status === 401) {
            return setMessage("error", "Données invalides");
        } else {
            return setMessage("error", "Une erreur s'est produite");
        }
    }
};



// ============================================ ACTIVATE ACCOUNT VIA ACTIVATION CODE =====================================
export const activateAccountViaCode = async ({ request }: { request: Request }) => {
    try {
        // Prepare payload
        const formData = await request.formData();
        const payload = Object.fromEntries(formData.entries());

        // Convert data to JSON
        const jsonPayload = JSON.stringify({
            activation_code: payload.activation_code,
        });
        console.log("JSON Payload ", jsonPayload);

        // Post data in api
        const responseActivate = await axios.post(
            `${process.env.REACT_APP_BASE_API_URL}${process.env.REACT_APP_API_ACTIVATE_ACCOUNT_VIA_CODE_ENDPOINT}`,
            jsonPayload,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
        console.log("Réponse de l'API :", responseActivate);

        // Verify the response for api server, if OK redirect to login page
        if (responseActivate.status === 200 || responseActivate.status === 201) {
            console.log("Account activated successfully");
            setMessage("success", "Votre compte est activé")
            return redirect(AppNavigation.Login);

        } else if (responseActivate.status === 404) {
            return setMessage("error", "User not found");
        } else {
            return setMessage("error", "Une erreur s'est produite lors de l'activation de votre compte");
        }
    } catch (error) {
        console.error("Erreur lors de la tentative d'activation du compte via l'API :", error);
        return setMessage("error", "Une erreur s'est produite lors du traitement");
    }
};




export const getMessageCost = async ({ request }: { request: any }) => {
    console.log("*** getMessageCost ***", request);
};


// ========================================================= Checking caracter in message ==============================================
function analyzeSmsCharacters(text: string) {
    // Définition des caractères pris en charge par le codage GSM 7 bits
    const gsm7BitChars =
        "@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞ\u000c" +
        "ÆæßÉ !" +
        '"#$%&\'()*+,-./0123456789:;<=>?' +
        "ABCDEFGHIJKLMNOPQRSTUVWXYZ" +
        "abcdefghijklmnopqrstuvwxyz" +
        "¡¿";

    // Caractères étendus du codage GSM 7 bits
    const gsm7BitExtendedChars = "^{}\\[~]|€";

    // Analyse des caractères non pris en charge
    const unsupportedChars: Record<string, number> = {};
    for (const char of text) {
        if (!gsm7BitChars.includes(char) && !gsm7BitExtendedChars.includes(char)) {
            if (unsupportedChars[char]) {
                unsupportedChars[char]++;
            } else {
                unsupportedChars[char] = 1;
            }
        }
    }

    // Calcul de l'encodage et du nombre maximal de caractères
    const encoding = Object.keys(unsupportedChars).length > 0 ? "UCS-2 (Unicode)" : "GSM 7-bit";
    const maxChars = encoding === "UCS-2 (Unicode)" ? 70 : 160;

    // Construction des résultats
    const result = {
        encoding: encoding,
        maxCharactersPerMessage: maxChars,
        messageLength: text.length,
        unsupportedCharacters: unsupportedChars,
        numberOfMessages: Math.ceil(text.length / maxChars),
    };

    // Debugging (facultatif)
    console.log("Unsupported characters:", unsupportedChars);

    return result;
}


// ========================================= create a new campaign function ===================================
export const createCampaign = async ({ request }: { request: Request }) => {
    try {
        // Prepare payload
        let formData = await request.formData();
        let payload: any = Object.fromEntries(formData);
        payload.payouts_info = JSON.parse(payload.payouts_info);
        console.log("\n \t # Payload  to creating camapign SMS :", payload);

        // Checking caracter of message
        console.log("\n \n \t CHECKING CARACTER OF MESSAGE TEXT");
        let caracter_message = analyzeSmsCharacters(payload.cm_message);
        console.log("\n \t # Characters analysis result :", caracter_message);

        // Post payload
        let response = await axiosInstance.post(
            process.env.REACT_APP_API_CREATE_CAMPAIGN_ENDPOINT as string,
            payload
        );
        console.log("\n \t # API response FOR CREATING CAMPAIGN:", response.data);
        if (response.data && response.data.status === "success") {
            setMessage("success", "campaign created successfully");
            // Redirect to home
            // return redirect(AppNavigation.Home);
            // Wait 4 seconds before redirecting
            return new Promise((resolve) => {
                setTimeout(() => {
                    resolve(redirect(AppNavigation.DraftCampaigns));
                }, 4000);
            });
        } else {
            return setMessage("error", "Failed to create campaign :" + response.data.message);
        }

    } catch (error) {
        console.error("Error while trying to create campaign:", error);
        if (axios.isAxiosError(error) && error.response?.data.error) {
            const errorData = error.response.data.error;
            console.log("** error data createCampaign 2 **");

            if (typeof errorData === "string") {
                console.log("errorData string : ", errorData);
                return { error: errorData };

            } else if (typeof errorData === "object") {
                console.log("errorData object : ", errorData);
                return { error: JSON.stringify(errorData) };
            }
        }
    }
};

// =============================================== edit campaign functions =============================================
export const editCampaign = async ({ request }: { request: Request }) => {
    try {
        console.log("\n\t * edit campaign function here");
        let formData = await request.formData();

        // Get campaign id
        const campaignId = formData.get("campaign-id")?.toString();
        if (!campaignId) {
            console.error("Campaign ID is missing");
            return { error: "Campaign ID is required." };
        }
        formData.delete("campaign-id");
        console.log("Campaign ID:", campaignId);

        // Prepare payload
        let payload: any = Object.fromEntries(formData);
        try {
            payload.payouts_info = JSON.parse(payload.payouts_info);
        } catch (error) {
            console.error("Invalid JSON format for payouts_info:", payload.payouts_info);
            return { error: "Invalid format for payouts_info. Please provide valid JSON." };
        }
        console.log("\n\t * Payload campaign to edit:", payload);

        // Post payload
        const apiEndpoint = (process.env.REACT_APP_API_EDIT_CAMPAIGN_ENDPOINT as string).replace(
            ":campaignId",
            campaignId
        );
        const response = await axiosInstance.patch(apiEndpoint, payload);

        // Check if the response is successful
        if (response.status === 200 && response.data.status === "success") {
            console.log("\n\t * Response from API to edit campaign:", response.data);
            setMessage("success", "Campaign updated successfully");

            // Wait 4 seconds before redirecting
            return new Promise((resolve) => {
                setTimeout(() => {
                    resolve(redirect(AppNavigation.DraftCampaigns));
                }, 4000);
            });

        } else {
            console.error("\n \t # Unexpected API response:", response);
            setMessage("error", "update campaign failed");
            return new Promise((resolve) => {
                setTimeout(() => {
                    resolve(redirect(AppNavigation.DraftCampaigns));
                }, 4000);
            });
        }

    } catch (error) {
        console.error("Error while trying to edit campaign:", error);
        if (axios.isAxiosError(error)) {
            const status = error.response?.status;
            const errorData = error.response?.data;

            console.log("\n \t # Axios error details **", { status, errorData });

            if (status === 400) {
                setMessage("error", "Invalid campaign data. Please check your input.");
            } else if (status === 404) {
                setMessage("error", "Campaign not found.");
            } else if (status === 500) {
                setMessage("error", "Server error. Please try again later.");
            } else {
                setMessage("error", "An unknown error occurred while updating the campaign.");
            }
        } else {
            setMessage("error", "An unexpected error occurred. Please try again later.");
        }
    }
};


export const cloneCampaign = async ({ request }: { request: Request }) => {
    try {
        // Prepare payload
        let formData = await request.formData();
        let payload: any = Object.fromEntries(formData);
        payload.payouts_info = JSON.parse(payload.payouts_info);
        console.log("Payload:", payload);

        // Post payload
        let response = await axiosInstance.post(
            process.env.REACT_APP_API_CREATE_CAMPAIGN_ENDPOINT as string,
            payload
        );
        console.log("API response:", response);

        // Redirect to home
        return redirect(AppNavigation.Home);
    } catch (error) {
        console.error("Error while trying to clone campaign:", error);
        // return "Something went wrong :(";
        if (axios.isAxiosError(error) && error.response?.data.error) {
            const errorData = error.response.data.error;
            console.log("** error data cloneCampaign 2 **");
            if (typeof errorData === "string") {
                console.log("errorData string : ", errorData);
                return { error: errorData };
            } else if (typeof errorData === "object") {
                console.log("errorData object : ", errorData);
                return { error: JSON.stringify(errorData) };
            }
        }
    }
};

export const deleteCampaign = async ({ request }: { request: Request }) => {
    try {
        // Prepare payload
        let formData = await request.formData();
        let campaignId = formData.get("campaign-id")?.toString() || "";
        console.log("Campaign ID:", campaignId);

        // Post payload
        let response = await axiosInstance.delete(
            (process.env.REACT_APP_API_DELETE_CAMPAIGN_ENDPOINT as string).replace(
                ":campaignId",
                campaignId
            )
        );
        console.log("API response:", response);
    } catch (error) {
        console.error("Error while trying to delete campaign:", error);

        return "Something went wrong :(";
    }
};

// export const homeAction = async ({ request }: { request: Request }) => {
//     try {
//         // Prepare payload
//         let formData = await request.formData();
//         // Get intended action
//         const action = formData.get("action") as unknown as HomeAction;
//         formData.delete("action");
//         const campaignCmId = formData.get("campaignCmId");
//         const campaignId = formData.get("campaignId");
//         formData.delete("campaignCmId");
//         switch (action) {
//             case HomeAction.ScheduleCampaing: {
//                 try {
//                     console.log("\t # Body to scheduling campaign : ", Object.fromEntries(formData.entries()));
//                     const payload_scheduled = Object.fromEntries(formData.entries());
//                     console.log("\n \t #:::::::>>>>> Schedule campaingID in CM :", campaignCmId);
//                     const response = await axiosInstance.put(
//                         (
//                             process.env.REACT_APP_API_CM_SCHEDULE_CAMPAIGN_ENDPOINT as string
//                         ).replace(":campaignId", campaignCmId as string),
//                         formData
//                     );

//                     setMessage("success", "campaign scheduled successfully");
//                     setTimeout(() => {
//                         return redirect(AppNavigation.ScheduledCampaigns);
//                     }, 4000);

//                 } catch (error: any) {
//                     console.log("\n \t # ERROR IN SCHEDULED ACTION :", error);
//                     if (error.response) {
//                         console.log("\n \t # Response error for scheduled :", error.response.data.Message);
//                         setMessage("error", error.response.data.MessageDetail);
//                     }
//                     if (axios.isAxiosError(error) && error.response?.data.Message) {
//                         const errorData = error.response.data.Message;
//                         if (typeof errorData === "string") {
//                             return { error: errorData };
//                         } else if (typeof errorData === "object") {
//                             return { error: errorData.Message };
//                         }
//                     }
//                 }
//                 break;
//             }
//             case HomeAction.DeleteCampaing: {
//                 try {
//                     console.log("\t # HomeAction.DeleteCampaing action");
//                     const response = await axiosInstance.delete(
//                         (process.env.REACT_APP_API_GET_CAMPAIGN_ENDPOINT as string).replace(
//                             ":campaignId",
//                             campaignId as string
//                         )
//                     );
//                     console.log("\t #=====> DELETED campaing, response:", response);

//                     if (response && response.status === 200) {
//                         setMessage(response.data.status, response.data.message);
//                         setTimeout(() => {
//                             // redirect(AppNavigation.Campaigns);
//                             window.location.href = AppNavigation.Campaigns;
//                         }, 4000);
//                     } else {
//                         console.log("\t #======> RESPONSE NOT 200 :", response);
//                         setMessage("error", "Unable to delete campaign");
//                     }
//                 } catch (error: any) {
//                     return setMessage(error.response.data.status, error.response.message);
//                 }
//                 break;
//             }
//             case HomeAction.CancelScheduled: {
//                 try {
//                     // Prepare payload
//                     console.log("\n \t # cancelCampaigns action");
//                     let formData = await request.formData();
//                     let payload = Object.fromEntries(formData.entries());

//                     console.log("\t # Payload to cancel campaign:", payload);

//                     // Get campaign id
//                     const campaignId = formData.get("campaignId")!.toString();
//                     formData.delete("campaignId");
//                     console.log("Campaign ID:", campaignId);

//                     // Post payload
//                     let url = (process.env.REACT_APP_API_CM_CANCEL_CAMPAIGN_ENDPOINT as string).replace(":campaignId", campaignId);
//                     let response = await axiosInstance.put(url, payload);
//                     console.log("\t # API response:", response);

//                     return redirect(AppNavigation.DraftCampaigns);
//                 } catch (error) {
//                     console.log("\t # Error while trying to create campaign:", error);
//                     if (axios.isAxiosError(error) && error.response?.data.Message) {
//                         const errorData = error.response.data.Message;
//                         if (typeof errorData === "string") {
//                             return { error: errorData };
//                         } else if (typeof errorData === "object") {
//                             return { error: errorData.Message };
//                         }
//                     }
//                     return setMessage("error", "Something went wrong");
//                 }
//             }
//         }
//     } catch (error) {
//         console.error("Error while trying to delete campaign:", error);

//         return "Something went wrong :(";
//     }
// };


export const homeAction = async ({ request }: { request: Request }) => {
    try {
        // Prepare payload - read form data once at the beginning
        const formData = await request.formData();
        const action = formData.get("action") as unknown as HomeAction;
        const campaignCmId = formData.get("campaignCmId");
        const campaignId = formData.get("campaignId");

        // Create payload object once
        const payload = Object.fromEntries(formData.entries());

        switch (action) {
            case HomeAction.ScheduleCampaing: {
                try {
                    console.log("\t # Body to scheduling campaign : ", payload);
                    console.log("\n \t #:::::::>>>>> Schedule campaingID in CM :", campaignCmId);

                    const response = await axiosInstance.put(
                        (process.env.REACT_APP_API_CM_SCHEDULE_CAMPAIGN_ENDPOINT as string)
                            .replace(":campaignId", campaignCmId as string),
                        payload
                    );
                    console.log("\t #======> RESPONSE SCHEDULED :", response);

                    if (response && response.status === 200) {
                        setMessage("success", "campaign scheduled successfully");
                        setTimeout(() => {
                            window.location.href = AppNavigation.ScheduledCampaigns;
                            return redirect(AppNavigation.ScheduleCampaing);
                        }, 4000);
                    } else {
                        console.log("\t #======> RESPONSE NOT 200 :", response);
                        setMessage("error", "Unable to schedule campaign");
                    }

                } catch (error: any) {
                    console.log("\n \t # ERROR IN SCHEDULED ACTION :", error.response);
                    if (error.response) {
                        console.log("\n \t # Response error for scheduled :", error.response.data.Message);
                        setMessage("error", error.response.data.error);
                        setTimeout(() => {
                            window.location.href = AppNavigation.Campaigns;
                        }, 4000);
                    }
                    if (axios.isAxiosError(error) && error.response?.data.Message) {
                        console.log("\n \t # Axios ERROR :", error);
                        setMessage("error", error.response.data.error);
                        setTimeout(() => {
                            window.location.href = AppNavigation.Campaigns;
                        }, 4000);
                    }
                }
                break;
            }
            case HomeAction.DeleteCampaing: {
                try {
                    console.log("\t # HomeAction.DeleteCampaing action");
                    const response = await axiosInstance.delete(
                        (process.env.REACT_APP_API_GET_CAMPAIGN_ENDPOINT as string)
                            .replace(":campaignId", campaignId as string)
                    );
                    console.log("\t #=====> DELETED campaing, response:", response);

                    if (response && response.status === 200) {
                        setMessage(response.data.status, response.data.message);
                        setTimeout(() => {
                            window.location.href = AppNavigation.Campaigns;
                        }, 4000);
                    } else {
                        console.log("\t #======> RESPONSE NOT 200 :", response);
                        setMessage("error", "Delete campaing failed");
                        setTimeout(() => {
                            // window.location.href = AppNavigation.Campaigns;
                        }, 4000);
                    }
                } catch (error: any) {
                    setMessage(error.response.data.status, error.response.message);
                    setTimeout(() => {
                        window.location.href = AppNavigation.Campaigns;
                    }, 4000);
                }
                break;
            }
            case HomeAction.CancelScheduled: {
                try {
                    console.log("\n \t # cancelCampaigns action");
                    console.log("\t # Payload to cancel campaign:", payload);

                    // Get campaign id
                    const campaign_id_cancel = formData.get("campaignId")!.toString();
                    formData.delete("campaignId");
                    console.log("\t # Campaign ID to canceling :", campaign_id_cancel);

                    let url = (
                        process.env.REACT_APP_API_CM_CANCEL_CAMPAIGN_ENDPOINT as string
                    ).replace(":campaignId", campaign_id_cancel);

                    let response = await axiosInstance.put(url, payload);
                    console.log("\t #======> RESPONSE CANCEL SCHEDULED :", response);

                    if (response && response.status === 200) {
                        setMessage(response.data.status, response.data.message);
                        setTimeout(() => {
                            window.location.href = AppNavigation.DraftCampaigns;
                        }, 4000);
                    } else {
                        setMessage(response.data.status, response.data.message);
                        setTimeout(() => {
                            // window.location.href = AppNavigation.Campaigns;
                        }, 4000);
                    }

                } catch (error: any) {
                    console.log("\t # Error while trying to cancel campaign:", error);
                    if (error.response) {
                        console.log("\n \t # Response error for canceling :", error.response.data.Message);
                        setMessage("error", error.response.data.MessageDetail);
                    }
                    if (axios.isAxiosError(error) && error.response?.data.Message) {
                        const errorData = error.response.data.Message;
                        if (typeof errorData === "string") {
                            return { error: errorData };
                        } else if (typeof errorData === "object") {
                            return { error: errorData.Message };
                        }
                    }
                    else {
                        return setMessage("error", "Unable to cancel campaign");
                    }
                }
            }
        }
    } catch (error) {
        console.error("Error in homeAction:", error);
        return "Something went wrong :(";
    }
};


export const addressBookAction = async ({ request, params }: { request: Request; params: { campaignId?: string } },) => {
    const campaignId = params.campaignId;
    console.log("\n \t # =====>>>>>>>>> CAMPAGNE ID :", campaignId);

    // Vérifier si campaignId est bien défini
    if (!campaignId) {
        console.error("Campaign ID is missing!");
        return redirect("/error");
    }

    try {
        // Préparer les données du formulaire
        const formData = await request.formData();
        console.log("\t # Data in formulaire completed :", Object.fromEntries(formData.entries()));

        // Récupérer l'action intentionnelle
        const action = formData.get("action") as AddressBookFormAction;
        const cmGroupId = formData.get("cm-group-id")?.toString();

        const add_simple_contact = Object.fromEntries(formData.entries());
        console.log("\t # GROUPE ID :", cmGroupId);

        // Valider les paramètres obligatoires
        if (!action || !cmGroupId) {
            console.error("Action ou CM Group ID manquant");
            setMessage("error", "Missing required parameters: action or cmGroupId.");
            return false;
        }

        const handleApiResponse = async (response: any, successMessage: string, errorMessage: string) => {
            if (response.status === 200 && response.data.status === "success") {
                setMessage("success", response.data.message || successMessage);

                // Attendre 4 secondes avant d'afficher le modal
                console.log("\t # The upload was successful ✅");
                setTimeout(() => {
                    window.location.href = (AppNavigation.CampaignAddressBook.replace(":campaignId", campaignId));
                }, 4000);

            }

            else if (response.status === 400) {
                setMessage("error", response.data.message || errorMessage);
                return new Promise((resolve) => {
                    setTimeout(() => {
                        resolve(redirect(AppNavigation.CampaignAddressBook.replace(":campaignId", campaignId)));
                    }, 4000);
                });
            }

            else if (!response && errorMessage) {
                setMessage("error", errorMessage);
                return new Promise((resolve) => {
                    setTimeout(() => {
                        resolve(redirect(AppNavigation.CampaignAddressBook.replace(":campaignId", campaignId)));
                    }, 4000);
                });
            }

            else {
                setMessage("error", response.data.message || errorMessage);
                return new Promise((resolve) => {
                    setTimeout(() => {
                        resolve(redirect(AppNavigation.CampaignAddressBook.replace(":campaignId", campaignId)));
                    }, 4000);
                });
            }
        };

        switch (action) {
            // ============================================ Vider les contacts =========================================
            case AddressBookFormAction.EmptyContacts:
                console.log("\t # Vider les contacts");
                try {
                    const response = await axiosInstance({
                        method: request.method,
                        url: (process.env.REACT_APP_API_CM_EMPTY_CONTACTS_ENDPOINT as string).replace(":cmGroupId", cmGroupId),
                        data: formData
                    });
                    console.log("\t #::::::::>>> Empty response :", response);
                    if (response && response.status === 200) {
                        setMessage("success", response.data.message);
                        // Ajoute un délai avant le redirect
                        setTimeout(() => {
                            window.location.href = (AppNavigation.CampaignAddressBook.replace(":campaignId", campaignId));
                        }, 4000);
                    } else {
                        console.log("\t #::::::::>>> Empty Failed:", response);
                        setMessage("error", "Empty failed");

                        setTimeout(() => {
                            window.location.href = (AppNavigation.CampaignAddressBook.replace(":campaignId", campaignId));
                        }, 4000);
                    }
                    return true;

                } catch (error) {
                    console.error("Erreur lors du vidage des contacts :", error);
                    setMessage("error", "Error ! " + error);
                    return redirect(AppNavigation.CampaignAddressBook.replace(":campaignId", campaignId));
                }

            // ======================================= Add Simple Contact Action =================================
            case AddressBookFormAction.AddContacts:
                console.log("\t # Ajouter des contacts via CSV");
                try {
                    const response = await axiosInstance({
                        method: request.method,
                        url: (process.env.REACT_APP_API_CM_UPLOAD_CONTACTS_CSV_ENDPOINT as string).replace(":cmGroupId", cmGroupId),
                        data: formData,
                        headers: { "Content-Type": "multipart/form-data" },
                    });
                    console.log("\t # Response from uploading contacts to group :", response);

                    if (!response.data) {
                        console.error("Erreur : Réponse vide de l'API");
                        return setMessage("erro", "Upload failed");
                    }

                    return handleApiResponse(response, "File uploaded successfully", "File upload failed.");

                } catch (error: any) {
                    console.error("\t # Erreur lors de l'upload du fichier CSV :", error);
                    if (error.response.data) {
                        console.error("Erreur : Réponse de l'API non valide :", error.response.data);
                        return setMessage(error.response.data.status, error.response.data.message);
                    }

                    else if (error.request) {
                        console.error("\t # Aucune réponse reçue du serveur :", error.request);
                        return setMessage(error.response.data.status, error.request);
                    }

                    else {
                        console.error("Erreur lors de la configuration de la requête :", error);
                        return setMessage(error.response.data.status, "An unexpected error occurred while uploading contacts.");
                    }
                }


            // ================================= Upload dynamiques Contact action ========================================
            case AddressBookFormAction.UploadDynamicContacts:
                // Vérification des données envoyées
                for (let [key, value] of formData.entries()) {
                    console.log("\n \t ACTION VERIFICATION :", key, value);
                }

                try {
                    // Appel API pour l'upload des contacts
                    const response = await axiosInstance({
                        method: request.method,
                        url: (process.env.REACT_APP_API_CM_UPLOAD_DYNAMIC_CONTACTS_ENDPOINT as string).replace(":cmGroupId", cmGroupId),
                        data: formData,
                        headers: { "Content-Type": "multipart/form-data" },
                    });

                    console.log("\n \t # Response from uploading dynamic contacts to group :", response.status);

                    // Validation de la réponse
                    if (!response || !response.data) {
                        console.error("Erreur : Réponse vide ou non valide de l'API");
                        return handleApiResponse(null, "File upload failed", "Empty or invalid response from server.");
                    }

                    if (response.status === 400) {
                        console.error("Erreur de validation des données :", response.data.message);
                        return handleApiResponse("error", "response.data.message", "File upload failed due to validation error.");
                    }

                    if (response.status >= 500) {
                        console.error("Erreur serveur :", response.data.message);
                        return handleApiResponse("error", "Internal server error.", "Server failed to process the request.");
                    }

                    // Succès
                    return handleApiResponse(response, "Dynamic contacts uploaded successfully", "Failed to upload dynamic contacts.");
                } catch (error: any) {
                    // Gestion des erreurs
                    console.error("Erreur lors de l'upload des contacts dynamiques :", error);

                    if (error.response) {
                        // Vérifier si error.response.data et error.response.data.message sont définis
                        const errorMessage = error.response.data?.message || "An error occurred while uploading contacts.";
                        console.error("\t # Détails de l'erreur :", errorMessage);

                        return setMessage(error.response.data.status, error.response.data?.message)
                    } else if (error.request) {
                        // Aucun réponse reçue (problème réseau ou serveur non joignable)
                        console.error("\t # Aucune réponse reçue du serveur :", error.request);
                        return setMessage("error", error.request);
                    } else {
                        // Autres erreurs (problème dans la configuration de la requête)
                        console.error("Erreur lors de la configuration de la requête :", error.message);
                        return setMessage("error", "An unexpected error occurred while uploading contacts.");
                    }
                }


            // ========================================== Créer un segment Data Warehouse =========================================
            case AddressBookFormAction.CreateDWHSegment:
                console.log("\t# Créer un segment DWH");
                try {
                    const response = await axiosInstance({
                        method: request.method,
                        url: process.env.REACT_APP_API_DWH_CREATE_SEGMENT_ENDPOINT as string,
                        data: formData,
                    });
                    return handleApiResponse(response, "Segment created successfully", "Failed to create segment.");
                } catch (error) {
                    console.error("Erreur lors de la création du segment DWH :", error);
                    return false;
                }

            // Choisir un segment Data Warehouse
            case AddressBookFormAction.ChooseDWHSegment:
                console.log("\t# Choisir un segment DWH");
                const cmCampaignId = formData.get("cm-campaign-id")?.toString();
                if (!cmCampaignId) {
                    setMessage("error", "Missing required parameter: cm-campaign-id.");
                    return false;
                }
                try {
                    const response = await axiosInstance({
                        method: request.method,
                        url: (process.env.REACT_APP_API_CM_CAMPAIGN_UPDATE_GROUP_ID_ENDPOINT as string).replace(":cmId", cmCampaignId),
                        data: formData,
                    });
                    return handleApiResponse(response, "Segment chosen successfully", "Failed to choose segment.");
                } catch (error) {
                    console.error("Erreur lors du choix du segment DWH :", error);
                    return false;
                }

            // Action par défaut (non autorisée)
            default:
                console.error(`Action non autorisée : ${action}`);
                throw new Response("Method Not Allowed", { status: 405 });
        }
    } catch (error: any) {
        console.error("Erreur générale dans addressBookAction :", error);
        setMessage("error", "An unexpected error occurred, please check the input fields and try again !");

        // Attendre 3 secondes avant d'actualiser la page
        setTimeout(() => {
            // window.location.href = window.location.pathname + window.location.search;
            return redirect(AppNavigation.CampaignAddressBook.replace(":campaignId", campaignId));
        }, 3000);
        // return redirect(AppNavigation.CampaignAddressBook);
    }
};


// ================================================= SEND BAT TEST FUNCTIONS =================================================
export const sendTest = async ({ request }: { request: Request }) => {
    try {
        // Get form data
        const formData = await request.formData();

        // Retrieve CM id from form data
        let cmId = formData.get("cm-id")!.toString();
        formData.delete("cm-id");
        console.log("CM ID:", cmId);

        // Prepare payload
        const payload = Object.fromEntries(formData.entries());
        console.log("Payload:", payload);

        // Post payload
        const response = await axiosInstance.post(
            (process.env.REACT_APP_API_CM_CAMPAIGN_SEND_TEST_ENDPOINT as string).replace(":cmId", cmId),
            payload
        );
        console.log("\t Send tes response via API :", response);
        if (response.status === 200 && response.data.status === "success") {
            setMessage("success", "Test sent successfully");
            setTimeout(() => {
                return redirect(AppNavigation.CampaignSendTest);
            }, 4000);
        } else {
            setMessage("error", response.data.message);
        }
        setTimeout(() => {
            return redirect(AppNavigation.CampaignSendTest);
        }, 4000);

    } catch (error) {
        console.error("Error while trying to delete campaign:", error);
        // Error return by the server
        if (axios.isAxiosError(error) && error.response?.data.error) {
            const errorData = error.response.data.error;
            if (typeof errorData === "string") {
                setMessage("error", errorData);
                return new Promise((resolve) => {
                    setTimeout(() => {
                        resolve(redirect(AppNavigation.DraftCampaigns));
                    }, 4000);
                });

            } else if (typeof errorData === "object") {
                setMessage("error", "errorData.Message");
                return new Promise((resolve) => {
                    setTimeout(() => {
                        resolve(redirect(AppNavigation.DraftCampaigns));
                    }, 4000);
                });
            }
        }

        // Unknown error
        setMessage("error", "invalid mobile format");
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(redirect(AppNavigation.DraftCampaigns));
            }, 4000);
        });
    }
};

export const addressBookDetailsAction = async ({
    params,
    request,
}: {
    params: Params;
    request: Request;
}) => {
    try {
        let formData = await request.formData();

        // Get intended action
        const action = formData.get(
            "action"
        ) as unknown as AddressBookDetailsFormAction;
        formData.delete("action");

        // Prepare payload
        let payload: any = Object.fromEntries(formData);
        console.log("Payload:", payload);

        console.log("CM Group ID:", params.addressBookId);

        switch (action) {
            case AddressBookDetailsFormAction.AddContact: {
                console.log("ato");
                // Post payload
                let response = await axiosInstance.post(
                    (process.env.REACT_APP_API_CM_ADD_CONTACT_ENDPOINT as string).replace(
                        ":cmGroupId",
                        params.addressBookId!
                    ),
                    payload
                );
                console.log("API response:", response);

                // Return success status
                return {
                    success: true,
                    action,
                };
            }

            case AddressBookDetailsFormAction.DeleteContacts: {
                console.log(
                    "*** Delete contact in addressBook ***",
                    typeof payload.contact_ids
                );
                // Post payload
                try {
                    payload.contact_ids = payload.contact_ids.split(",");
                    console.log("payload.contact_ids : ", payload.contact_ids);
                    let response = await axiosInstance({
                        method: "delete",
                        url: process.env
                            .REACT_APP_API_CM_DELETE_CONTACTS_ENDPOINT as string,
                        data: payload,
                    });
                    console.log("API response:", response);

                    // Return success status
                    return {
                        success: true,
                        action: AddressBookDetailsFormAction.DeleteContacts,
                    };
                } catch (error) {
                    console.error("Error while trying to delete campaign:", error);

                    // Error return by the server
                    if (axios.isAxiosError(error) && error.response?.data.error) {
                        const errorData = error.response.data.error;
                        if (typeof errorData === "string") {
                            return { error: errorData };
                        } else if (typeof errorData === "object") {
                            return { error: errorData.Message };
                        }
                    }

                    // Unknown error
                    return { error: "Something went wrong :(" };
                }
            }

            default: {
                throw new Response("", { status: 405 });
            }
        }
    } catch (error) {
        console.error("Error while trying to create contact:", error);

        // Error return by the server
        if (axios.isAxiosError(error) && error.response?.data.detail) {
            return {
                success: false,
                error: error.response?.data.detail,
            };
        }

        return {
            success: false,
            error: "Something went wrong :(",
        };
    }
};

export const cancelCampaigns = async ({ request }: { request: Request }) => {
    try {
        // Prepare payload
        console.log("\n \t # cancelCampaigns action");
        let formData = await request.formData();
        let payload = Object.fromEntries(formData.entries());

        console.log("\t # Payload to cancel campaign:", payload);

        // Get campaign id
        const campaignId = formData.get("campaignId")!.toString();
        formData.delete("campaignId");
        console.log("Campaign ID:", campaignId);

        // Post payload
        let url = (
            process.env.REACT_APP_API_CM_CANCEL_CAMPAIGN_ENDPOINT as string
        ).replace(":campaignId", campaignId);

        let response = await axiosInstance.put(url, payload);
        console.log("API response:", response);

        return redirect(AppNavigation.DraftCampaigns);
    } catch (error) {
        console.error("Error while trying to create campaign:", error);
        if (axios.isAxiosError(error) && error.response?.data.Message) {
            const errorData = error.response.data.Message;
            if (typeof errorData === "string") {
                return { error: errorData };
            } else if (typeof errorData === "object") {
                return { error: errorData.Message };
            }
        }
        return "Something went wrong";
    }
};

export const switchDefaultCmAccount = async ({
    request,
}: {
    request: Request;
}) => {
    console.log("-- switchDefaultCmAccount action --");
    let formData = await request.formData();
    let data = Object.fromEntries(formData.entries());
    console.log("Payload:", data);
    let payload = new FormData();
    payload.append("default_cm_account", data.cm_account_id);
    const userId = data.user_id!.toString();
    // Post payload
    let response = await axiosInstance.patch(
        (process.env.REACT_APP_API_UPDATE_USER_ENDPOINT as string).replace(
            ":userId",
            userId
        ),
        payload
    );
    console.log("API response:", response);
    // Redirect to home
    return redirect(AppNavigation.Home);
};

export const addressBookListAction = async ({
    request,
}: {
    request: Request;
}) => {
    console.log("-- addressBookListAction --");
    let formData = await request.formData();
    let payload = Object.fromEntries(formData.entries());
    console.log("Payload:", payload);

    // Get intended action
    const action = formData.get("action") as unknown as AddressBookListAction;
    formData.delete("action");

    switch (action) {
        case AddressBookListAction.CreateAddressBook: {
            console.log("** CreateAddressBook Action **");
            // Post payload
            let response = await axiosInstance.post(
                process.env.REACT_APP_API_CM_GET_ADDRESS_BOOKS_ENDPOINT as string,
                payload
            );
            console.log("API response:", response);
            // Return success status
            return {
                success: true,
            };
        }

        case AddressBookListAction.DeleteAddressBook: {
            // Post payload
            console.log("** DeleteAddressBook Action **");
            const addressBookId = formData.get("addressBookId") as string;
            formData.delete("addressBookId");

            console.log("addressBookId : ", typeof addressBookId);

            let response = await axiosInstance.delete(
                (
                    process.env.REACT_APP_API_DELETE_ADDRESSBOOK_ENDPOINT as string
                ).replace(":addressBookId", addressBookId),
                payload
            );
            console.log("response : ", response);
            console.log("API response:", response.status);

            // // Return success status
            if (response.status === 200 || response.status === 204) {
                return {
                    success: true,
                    action: AddressBookListAction.DeleteAddressBook,
                };
            } else {
                return {
                    error: true,
                };
            }
        }

        default: {
            throw new Response("", { status: 405 });
        }
    }
};

export const checkNumberByHlr = async ({ request }: { request: Request }) => {
    console.log("-- checkNumberByHlr action --");
    let formData = await request.formData();
    let data = Object.fromEntries(formData.entries());
    console.log("Payload formData:", data);
    try {
        let response = await axiosInstance({
            method: request.method,
            url: process.env.REACT_APP_API_CM_CHECK_NUMBER_HLR_ENDPOINT as string,
            data: formData,
            headers: { "Content-Type": "multipart/form-data" },
        });
        // console.log("response : ", response);

        // const url = window.URL.createObjectURL(new Blob([response.data]));
        // const a = document.createElement("a");
        // a.href = url;
        // a.download = "export.csv";
        // document.body.appendChild(a);
        // a.click();
        // window.URL.revokeObjectURL(url);

        console.log("response : ", response);
        if (response.status === 201 || response.status === 200) return true;
    } catch (error: any) {
        console.log("Error : ", error.response.data.error);
        if (axios.isAxiosError(error) && error.response?.data.error) {
            const errorData = error.response.data.error;
            if (typeof errorData === "string") {
                return { error: errorData };
            } else if (typeof errorData === "object") {
                return { error: errorData.Message };
            }
        }
    }
};

export const downloadCsv = async ({ file_path }: { file_path: string }) => {
    try {

        // const response = await axios.get(apiUrl, { responseType: 'blob' });

        let response = await axiosInstance({
            method: "get",
            url: process.env.REACT_APP_API_DOWNLOAD_CSV_HLR as string + file_path,
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const a = document.createElement('a');
        a.href = url;
        a.download = getFileNameFromPath({ file_path: file_path });
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error('Error downloading CSV file:', error);
    }
};


export function getFileNameFromPath({ file_path }: { file_path: string }) {
    const pathSegments = file_path.split(/[\\/]/);
    const fileName = pathSegments[pathSegments.length - 1];
    return fileName;
}


// ============================================== CHECK PENDING HLR OPERATION WITH INFOBIP =============================================
export async function checkPendingHlrOperationWithInfobip() {
    try {
        const responseCheckingHlr = await axiosInstance({
            method: "get",
            url: process.env.REACT_APP_API_CHECK_HLR_OPERATION_WITH_INFOBIP_ENDPOINT as string,
        });
        if (responseCheckingHlr.status === 200) {
            console.log("Checking hlr operation successfully");
            return setMessage("success", "Checking hlr operation successfully");

        } else if (responseCheckingHlr.status === 500) {
            console.error("Server error while checking hlr operation");
            return setMessage("error", "Server error ");

        } else {
            console.error("Error when checking hlr operation");
            return setMessage("error", "Error when checking hlr operation");
        }

    } catch (error) {
        console.error("Error when checking hlr operation:", error);
        return setMessage("error", "Error when checking hlr operation");
    }
}

// ======================================= getting random images in login pages =================================
export const getRandomImages = async () => {
    let url = "https://www.kontikimedia.com/images/sms/index.webp";
    let index = Math.floor(Math.random() * 60);
    url = url.replace("index", index.toString());
    return url
};

// ========================================= encoding and decoding text  in base64 ======================================
export const decode_text_base64 = (str: string): string | null => {
    try {
        return decodeURIComponent(escape(atob(str)));
    } catch (error) {
        console.error("Error decoding Base64:", error);
        return null;
    }
};

export const encode_text_base64 = (str: string | number | boolean): string | null => {
    try {
        const encodedStr = encodeURIComponent(String(str)).replace(/%([0-9A-F]{2})/g,
            (_, p1) => String.fromCharCode(parseInt(p1, 16))
        );
        return btoa(encodedStr);
    } catch (error) {
        console.error("Error encoding Base64:", error);
        return null;
    }
};

export const base64EncodeUnicode = (str: string | number | boolean): string | null => {
    try {
        return encode_text_base64(str);
    } catch (error) {
        console.error("Error encoding Unicode to Base64:", error);
        return null;
    }
};
